import { useGetAllAccounts } from '@/api/generated/accounts/accounts';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/language-hooks';
import { Plug } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ConnectAccountsStepProps {
  onContinue: () => void;
}

export const ConnectAccountsStep = ({ onContinue }: ConnectAccountsStepProps) => {
  const { t } = useLanguage();
  const { data: accountsResponse, isLoading } = useGetAllAccounts();
  const accounts = accountsResponse?.items ?? [];

  const assetAccounts = accounts.filter((account) => account.type !== 'liability');
  const connectedCount = assetAccounts.length;

  return (
    <div className='space-y-4'>
      <p className='text-muted-foreground text-sm'>{t('goalPlanning.connect.description')}</p>

      <div className='border-border bg-muted/30 rounded-lg border p-4'>
        <p className='text-foreground text-sm font-medium'>
          {isLoading
            ? t('common.loading')
            : t('goalPlanning.connect.accountsLinked', { count: connectedCount })}
        </p>
        <p className='text-muted-foreground mt-1 text-xs'>{t('goalPlanning.connect.hint')}</p>
      </div>

      <Link
        to='/settings/connections'
        className='text-primary inline-flex items-center gap-1.5 text-sm font-medium hover:underline'
      >
        <Plug className='h-4 w-4' aria-hidden />
        {t('goalPlanning.connect.manageConnections')}
      </Link>

      <Button type='button' className='w-full' onClick={onContinue}>
        {t('goalPlanning.connect.continue')}
      </Button>
    </div>
  );
};
